import { render } from "./managerInfo.vue?vue&type=template&id=6b5b3c74&scoped=true"
import script from "./managerInfo.vue?vue&type=script&lang=js"
export * from "./managerInfo.vue?vue&type=script&lang=js"

import "./managerInfo.vue?vue&type=style&index=0&id=6b5b3c74&lang=less&scoped=true"

import exportComponent from "/home/jenkins/agent/workspace/yf-sassmc4ct_wyf-saas-web_master/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6b5b3c74"]])

export default __exports__